import { useState } from 'react';
import { TabBar } from './components/TabBar';
import { Settings } from './screens/Settings';
import { Cards } from './screens/Cards';
import { Done } from './screens/Done';
import { Drill } from './screens/Drill';
import { Home } from './screens/Home';
import { Tools } from './screens/Tools';
import { Topics } from './screens/Topics';
import { Wins } from './screens/Wins';
import { StoreProvider, useApp } from './store/useApp';

export function App() {
  return (
    <StoreProvider>
      <Shell />
    </StoreProvider>
  );
}

function Shell() {
  const { state, ready } = useApp();
  const [settingsOpen, setSettingsOpen] = useState(false);

  // Leaving a tab closes Settings, so it can never be left hanging over
  // another screen after a tab change.
  const showSettings = settingsOpen && state.screen === 'home' && state.tab === 'wins';

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        justifyContent: 'center',
        background: 'var(--bg)',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 'var(--col)',
          height: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          background: 'var(--bg)',
          color: 'var(--text)',
          overflow: 'hidden',
          paddingTop: 'max(10px, env(safe-area-inset-top))',
        }}
      >
        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
          {/* Nothing renders until the saved state is back, so a returning
              user never sees a flash of zeroed progress before her real
              numbers arrive. */}
          {ready &&
            (showSettings ? (
              <Settings onBack={() => setSettingsOpen(false)} />
            ) : (
              <Body
                screen={state.screen}
                tab={state.tab}
                onOpenSettings={() => setSettingsOpen(true)}
              />
            ))}
        </div>
        {state.screen === 'home' && <TabBar />}
      </div>
    </div>
  );
}

function Body({
  screen,
  tab,
  onOpenSettings,
}: {
  screen: string;
  tab: string;
  onOpenSettings: () => void;
}) {
  if (screen === 'drill') return <Drill />;
  if (screen === 'done') return <Done />;
  if (tab === 'topics') return <Topics />;
  if (tab === 'tools') return <Tools />;
  if (tab === 'wins') return <Wins onOpenSettings={onOpenSettings} />;
  if (tab === 'cards') return <Cards />;
  return <Home />;
}
